import React from "react";
import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeliverImage from "../../../assets/images/PincodeDeliver.png";
import CancelImage from "../../../assets/images/PincodeCancel.png";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "75vw", 
    sm: "30vw", 
  },
  bgcolor: "white",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const DeliveryModal = ({ open, handleClose ,Pincodeflag }) => {
  // console.log(Pincodeflag);
  
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={ Pincodeflag == "Yes" ? DeliverImage : CancelImage}
          alt="Delivery"
          style={{ maxWidth: "100%", height: "auto", marginBottom: 16 }}
        />
        {/* <Typography sx={{ fontWeight: 200, fontSize: 20 }}>
          We deliver to your door — faster than your Wi-Fi can buffer!
        </Typography> */}

        <p style={{fontSize:'20px' ,color:"#181D27" , fontWeight:'bold'}}>  
          {Pincodeflag == "Yes" ? "We deliver to your door — faster than your Wi-Fi can buffer!" : "Oops! Delivery isn’t available there just yet... but we’re on our way!" }
        </p>
      </Box>
    </Modal>
  );
};

export default DeliveryModal;
